import { FormStore } from "../../../Core/Store/CandyStore";

import { IHelperFunctionsStoreAccessor } from "./IHelperFunctionsCallContext";

export class HelperFunctionsStoreAccessor implements IHelperFunctionsStoreAccessor {
    readonly #store: FormStore;

    public constructor(store: FormStore) {
        this.#store = store;
    }

    public dispatch(action: unknown): void {
        // eslint-disable-next-line no-console
        console.error("Accessing to store via helper function is forbidden. Please oo not use this method.");
        // @ts-ignore
        this.#store.dispatch(action);
    }
}
